import type { ThemeConfig } from 'antd'

import { palette } from './palette'

export const DESIGN_SYSTEM_PREFIX = 'design-system'

export const designSystemTheme: ThemeConfig = {
  token: {
    colorPrimary: palette.colorPrimary,
    colorError: palette.colorError,
    colorBorder: palette.colorBorder,
    colorTextSecondary: palette.colorTextSecondary,
    colorTextDisabled: palette.colorTextDisabled,
    colorTextPlaceholder: palette.colorTextPlaceholder,
    borderRadius: 6,
    controlHeight: 32,
    controlHeightLG: 40,
    controlHeightSM: 28,
    colorInfoBg: palette.colorPrimaryBg,
    colorInfoBorder: palette.colorPrimaryFocusBorder,
    colorSuccessBg: palette.colorSuccessSurface,
    colorSuccessBorder: palette.colorSuccessBorder,
    colorErrorBg: palette.colorErrorSurface,
    colorErrorBorder: palette.colorErrorBorder,
    colorWarningBg: palette.colorWarningSurface,
    colorWarningBorder: palette.colorWarningBorder
  },
  components: {
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
      contentFontSizeSM: 12,
      paddingInlineLG: 16,
      borderRadiusLG: 6,
      borderRadiusSM: 5
    },
    Form: {
      labelHeight: 16,
      verticalLabelPadding: '0'
    },
    Input: {
      inputFontSizeLG: 14,
      inputFontSizeSM: 14,
      paddingBlock: 4,
      paddingBlockLG: 8.5,
      paddingBlockSM: 2,
      hoverBorderColor: palette.colorPrimaryBorderHover,
      activeShadow: `0 0 0 2px ${palette.colorPrimaryFocusBorder}`,
      errorActiveShadow: `0 0 0 2px ${palette.colorErrorAlpha10}`,
      warningActiveShadow: `0 0 0 2px ${palette.colorWarningAlpha10}`
    },
    Select: {
      optionFontSize: 14,
      hoverBorderColor: palette.colorPrimaryBorderHover,
      activeBorderColor: palette.colorPrimary,
      activeOutlineColor: palette.colorPrimaryFocusBorder
    },
    DatePicker: {
      inputFontSizeLG: 14,
      inputFontSizeSM: 14,
      paddingBlock: 4,
      paddingBlockLG: 8.5,
      paddingBlockSM: 2,
      hoverBorderColor: palette.colorPrimaryBorderHover,
      activeBorderColor: palette.colorPrimary,
      activeShadow: `0 0 0 2px ${palette.colorPrimaryFocusBorder}`,
      cellWidth: 36,
      cellHeight: 24
    },
    Table: {
      headerBg: palette.colorNeutralBg,
      headerSortHoverBg: palette.colorNeutralBgHover,
      headerSortActiveBg: palette.colorNeutralBgHover,
      headerSplitColor: 'transparent',
      rowHoverBg: palette.colorPrimaryBg,
      rowSelectedBg: palette.colorPrimaryBgHover,
      rowSelectedHoverBg: palette.colorPrimaryBgActive,
      borderColor: palette.colorBorder,
      cellPaddingBlockMD: 8,
      cellPaddingInlineMD: 8,
      cellPaddingBlockSM: 4,
      cellPaddingInlineSM: 4
    },
    Tabs: {
      inkBarColor: palette.colorPrimary,
      itemSelectedColor: palette.colorPrimary,
      itemHoverColor: palette.colorPrimary,
      itemColor: palette.colorText,
      horizontalItemGutter: 16,
      titleFontSize: 14,
      titleFontSizeLG: 16,
      titleFontSizeSM: 14,
      horizontalItemPadding: '12px 0',
      horizontalItemPaddingLG: '16px 0',
      horizontalItemPaddingSM: '8px 0',
      verticalItemPadding: '8px 24px'
    },
    Segmented: {
      trackBg: palette.colorNeutralBg,
      itemSelectedBg: palette.colorPrimary,
      itemSelectedColor: '#ffffff',
      itemActiveBg: 'transparent',
      trackPadding: 2,
      itemColor: palette.colorText,
      itemHoverBg: palette.colorNeutralBgHover
    },
    Switch: {
      trackHeight: 16,
      handleSize: 12,
      trackPadding: 2
    },
    Badge: {
      textFontWeight: 600
    },
    Steps: {
      // Official component tokens (see antd's `steps/style` ComponentToken).
      iconSize: 32,
      iconSizeSM: 24,
      // Alias tokens scoped to Steps only — these back the `finish`/`wait`
      // icon fill colors and the incomplete tail color that antd derives
      // internally (see `prepareComponentToken` in antd's steps/style),
      // there are no dedicated component tokens for them.
      controlItemBgActive: palette.colorPrimaryBg,
      colorFillContent: palette.colorNeutralFill,
      colorSplit: palette.colorNeutralFill,
      colorTextLabel: palette.colorTextDisabled,
      colorTextDescription: palette.colorTextDisabled
    }
  }
}
